import { render, staticRenderFns } from "./statTypeButton.vue?vue&type=template&id=385d9ee0&scoped=true&"
import script from "./statTypeButton.vue?vue&type=script&lang=js&"
export * from "./statTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./statTypeButton.vue?vue&type=style&index=0&id=385d9ee0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d9ee0",
  null
  
)

export default component.exports